// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hj28N","content":"styles_content__3gr_4","row":"styles_row__dmPqv","footer":"styles_footer__3oGZ6","phraseLength":"styles_phraseLength__lFLNJ"};